// extracted by mini-css-extract-plugin
export default {"bgGroup":"NmObkh5zBn1wiDv_hPjw","bgCard":"tbrHjy7U2divHqL9gcgd","bgImg":"XoPo9_SpTaZGMDUqpjol"};